<fieldset [ngClass]="formControl.invalid ? 'error' : 'noerror'">
	<legend aria-label="Empfänger auswählen" role="group"> {{ formControl.valid ? "Empfänger" : "Empfänger *" }}</legend>
	@for (kategorie of getKontaktKategorien(); track kategorie.label) {
		<mat-checkbox
				[formControl]="kategorie.formControl"
				color="primary"
				class="focus-inwards-dark"
				[attr.data-test-id]="kategorie.testId">
			{{ kategorie.label }}
		</mat-checkbox>
	}
</fieldset>
@if (formControl.invalid) {
	<mat-error data-test-id="invalid-checkbox-message">
	Bitte Empfänger wählen
</mat-error>
}
